import type { AxiosResponse } from 'axios';

export interface WebhookHistory {
  product: {
    id: number;
    title: string;
  };
  customer: {
    name: string;
    email: string;
  };
  _id: string;
  producerId: number;
  type: WebhookTypes;
  payloadId: string;
  url: string;
  sentData: string;
  entityId: number;
  entityStatus: number;
  sends: Send[];
  updated_at: string;
  created_at: string;
  __v: number;
  urlId: string;
  lastSend: Send;
  state: string;
}

interface Send {
  url: string;
  payload_id: string;
  invoice_id: number;
  content_id: number;
  producer_id: number;
  returnData: string;
  returnStatus: string;
  status: boolean;
  deleted: boolean;
  _id: string;
  updated_at: string;
  created_at: string;
  __v: number;
}

export type WebhookTypes = 'invoice' | 'abandonment' | 'contract';
export type WebhookTypeFilter = WebhookTypes | 'all';
export interface Webhook {
  created_at: string;
  state: WebhookStatus;
  customer_id: number;
  deleted: boolean;
  description: string;
  internal: boolean;
  product_id: number;
  product_name: string;
  status: boolean;
  type: WebhookTypes;
  updated_at: string;
  inQueueCount: number;
  url: string;
  __v: number;
  _id: string;
}

export interface WebhookHistoryFilter {
  date?: [string, string];
  product_id?: number[];
  customer?: string;
  entityId?: string;
  status?: string;
}

export interface WebhookFilter {
  url?: undefined | string;
  status?: string;
  type?: string;
}

export interface TestResult {
  valid: boolean;
  response: Pick<AxiosResponse, 'data' | 'status' | 'statusText'> & { duration: number; helperText: string };
  requestData: string;
}
export interface FieldsTestWebHook {
  type: string;
  status: number;
}

export interface FieldsWebHook {
  description: string;
  product_id: number;
  url: string;
  type: WebhookTypes;
  _id?: string;
}

export interface ProductWebhook {
  productId: number;
  title: string;
}

export enum InvoiceStatusByName {
  paid = 'Paga',
  negociated = 'Negociada',
  refunded = 'Reembolsada',
  waiting_refund = 'Aguardando Reembolso',
  canceled = 'Cancelada',
  duplicated = 'Duplicada',
  expired = 'Expirada',
  open = 'Aberta',
  waiting_payment = 'Aguardando Pagamento',
  analysing = 'Em analíse',
  recovering = 'Em recuperação',
}

export enum WebhookStatus {
  active = 'active',
  failing = 'failing',
  inactive = 'inactive',
}
export enum WebhookTypeAlias {
  subscription = 'Contrato',
  invoice = 'Fatura',
  abandonment = 'Abandono de carrinho',
}

export enum WebhookStatusAlias {
  active = 'Ativo',
  failing = 'Com erro',
  inactive = 'Inativo',
}

export const InvoiceStatus = {
  1: 'Aberta',
  3: 'Paga',
  4: 'Cancelada',
  6: 'Aguardando Reembolso',
  7: 'Reembolsado',
  9: 'Duplicada',
  10: 'Expirada',
  11: 'Em recuperação',
  12: 'Aberta',
  13: 'Aberta',
  14: 'Aberta',
  15: 'Aguardando Pagamento',
  19: 'Negociada',
};

export const SubscriptionStatus = {
  1: 'Em Dia',
  2: 'Aguardando Pagamento',
  3: 'Suspenso',
  4: 'Cancelado',
  7: 'Atrasado',
  9: 'Finalizado',
  10: 'Trial',
  11: 'Inadimplente',
  19: 'Negociada',
};

export const WebhookTypes = [
  { label: 'Fatura', value: 'invoice' },
  { label: 'Abandono de carrinho', value: 'abandonment' },
];
